export const CLEAR_STATE = 'app/CLEAR_STATE';



// WEBPACK FOOTER //
// ./src/state/reducers/app/appTypes.js